import { Injectable } from '@angular/core';
import { environment  } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  private readonly baseApiRoute = `${environment.apiBaseUrl}`;
  
  constructor(private http: HttpClient) { }

  public VerifyUser(req : any): Observable<any> {
    return this.http.post<any>(`${this.baseApiRoute}User/VerifyUser`,req);
  }
 
  public changepwdCanidateProfile(CandidateProfile : any): Observable<any> {
    return this.http.post<any>(`${this.baseApiRoute}CandidateProfile/ChangeCandidateProfilePwd`, CandidateProfile);
  }
}
